module.exports = __webpack_public_path__ + "static/media/acla-logo.046a7500.svg";